import { BrowserRouter } from 'react-router-dom';
import { PartnerThemeProvider } from './app/PartnerThemeProvider';
import { PartnerRouter } from './routes/PartnerRouter';

export default function App() {
  return (
    <PartnerThemeProvider>
      <BrowserRouter>
        <PartnerRouter />
      </BrowserRouter>
    </PartnerThemeProvider>
  );
}
